module.exports = __webpack_public_path__ + "img/0.7dd44d9a.png";